import { presentAppUpdateCompleteAlert, presentAppUpdateLoading } from '@/utils/appUpdateUi.js';

const SW_URL = '/sw.js';
const LAUNCH_GRACE_MS = 8000;

const hadControllerAtPageStart = typeof navigator !== 'undefined'
  && 'serviceWorker' in navigator
  && !!navigator.serviceWorker.controller;

const launchedAt = Date.now();

function isWithinLaunchGrace() {
  return Date.now() - launchedAt < LAUNCH_GRACE_MS;
}

async function promptReload() {
  await presentAppUpdateCompleteAlert();
  window.location.reload();
}

export default () => {
  if (import.meta.env.DEV) {
    console.log('Service Worker disabled in development');
    return;
  }

  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker unavailable');
    return;
  }

  let refreshing = false;
  let expectUserFacingUpdate = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing || !hadControllerAtPageStart) return;
    refreshing = true;
    if (expectUserFacingUpdate) {
      void promptReload();
      return;
    }
    window.location.reload();
  });

  const checkForUpdates = async (registration) => {
    try {
      await registration.update();
    } catch (error) {
      console.error('SW update check failed:', error);
    }
  };

  const start = async () => {
    try {
      const registration = await navigator.serviceWorker.register(SW_URL, {
        updateViaCache: 'none',
      });

      registration.addEventListener('updatefound', async () => {
        const newWorker = registration.installing;
        if (!newWorker || !registration.active || !hadControllerAtPageStart) return;
        if (isWithinLaunchGrace()) return;

        expectUserFacingUpdate = true;
        const loading = await presentAppUpdateLoading();

        newWorker.addEventListener('statechange', async () => {
          if (newWorker.state === 'activated') {
            await loading.dismiss();
          }
        });
      });

      await checkForUpdates(registration);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          void checkForUpdates(registration);
        }
      });
    } catch (error) {
      console.error('SW registration failed:', error);
    }
  };

  if (document.readyState === 'complete') {
    void start();
  } else {
    window.addEventListener('load', () => {
      void start();
    });
  }
};
